<template>
    <div class="app-permission">
        <mu-title color="primary">Sem permissão de acesso</mu-title>
        <p>Você não tem permissão para acessar a essa página.</p>
    </div>
</template>

<script>
    export default {
        name: 'app-permission-unauthenticated'
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .app-permission
        text-align center
        padding 50px 0
        color $grey

</style>
